export default "__VITE_ASSET__tKlWIwoA__"